import { render, staticRenderFns } from "./LivingPortfolio.vue?vue&type=template&id=3e842120&scoped=true"
import script from "./LivingPortfolio.vue?vue&type=script&lang=js"
export * from "./LivingPortfolio.vue?vue&type=script&lang=js"
import style0 from "./LivingPortfolio.vue?vue&type=style&index=0&id=3e842120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e842120",
  null
  
)

export default component.exports